import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoutes = () => {
    const { user } = useSelector(state => state.auth);
    const location = useLocation();

    // Si no está logueado, lo manda al login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
   //    console.log('user', user);
    // Si está logueado pero debe cambiar su clave, y no está ya en /cambiar-password
    if (user.usuario?.cambiar_password && location.pathname !== '/cambiar-password') {
        return <Navigate to="/cambiar-password" replace />;
    }

    return <Outlet />;
};

export default PrivateRoutes;
